// „Склад по продукт" — своят склад на продукта в ресторанта, откъдето се
// изписва по подразбиране при разнасяне на отчет и при брака от сторно.
// Правилото е на BE (`warehouse_routing.py`), за ВСЯКА съставка: своят склад на
// продукта > складът на станцията на рецептата > нищо (операторът избира).
// Задава се само ИЗРИЧНО: „Винаги от <склад>" в разнасянето или секцията в
// „Конфигурации" — никога тихо от последния избор.
import { api } from "./client";

// Откъде е предложен складът в прегледа на разнасянето.
export type DefaultWarehouseSource = "product" | "station";

// Предизбрана позиция на продукт в прегледа (`ReportPostingProduct.defaultAllocations`):
// BE ги праща с най-големия дял първи; празен списък = част от нуждата е без
// склад и продуктът стои без предизбор.
export interface ReportPostingDefaultAllocation {
  warehouseId: number;
  quantity: number;
  source: DefaultWarehouseSource;
}

// Един зададен склад по продукт. `valid: false` — складът вече не е на
// ресторанта: BE го пренебрегва (решава станцията), не го трие сам.
export interface ProductWarehouse {
  productId: number;
  productName: string;
  warehouseId: number;
  warehouseName: string | null;
  valid: boolean;
  updatedAt: string | null;
  updatedByName: string | null;
}

export async function getProductWarehouses(): Promise<ProductWarehouse[]> {
  const res = await api.get<ProductWarehouse[]>("/inventory/product-warehouses");
  return res.data;
}

export async function setProductWarehouse(
  productId: number,
  warehouseId: number,
): Promise<ProductWarehouse> {
  const res = await api.put<ProductWarehouse>(`/inventory/product-warehouses/${productId}`, {
    warehouseId,
  });
  return res.data;
}

export async function deleteProductWarehouse(productId: number): Promise<void> {
  await api.delete(`/inventory/product-warehouses/${productId}`);
}
